import axios from 'axios';
import { logout } from './auth';
import { getBaseUrl, refreshToken } from './helpers';

// API Endpoints
const GET_BUILDING_LIST_ENDPOINT = `/building/api/buildings/?partial=1&is_pi=1`;

// axios.interceptors.response.use(((response) => {
//   console.log(`interceptor, ${response}`)
// }, (error) => {
//   if (error.response.status !== 401) {
//     return Promise.reject(error);
//   }

//   // return refreshToken(globalEnv).then(() => {
//   //   const authToken = JSON.parse(sessionStorage.getItem('token'));
//   //   error.config._isRetryRequest = true;
//   //   error.config.headers.Authorization = `JWT ${authToken}`;

//   //   return axios.request(error.config);
//   // }).catch(() => {
//   //   const tokenError = new Error('Cannot refresh token');
//   //   tokenError.originalError = error;
//   //   return Promise.reject(tokenError);
//   // });
//   const BASE_URL = getBaseUrl(globalEnv);
//   const refreshToken = JSON.parse(localStorage.getItem('refresh_token'));

//   return axios
//     .post(`${BASE_URL}${REFRESH_TOKEN_ENDPOINT}`, {
//       refreshToken,
//     })
//     .then((response) => {
//       const user = response.data;

//       if (user && user.token && user.refresh_token) {
//         // handle storing user details and jwt token in local storage to keep user logged in
//         localStorage.setItem('current_user', JSON.stringify(user.user))
//         localStorage.setItem('refresh_token', JSON.stringify(user.refresh_token));
//         sessionStorage.setItem('token', JSON.stringify(user.token));
//         return user;
//       }

//       error.hasRefreshedToken = true;
//       return Promise.reject(error);
//     })
//     .catch(() => {
//       const tokenError = new Error("Cannot refresh token");
//       tokenError.originalError = error;
//       return Promise.reject(tokenError);
//     });
// }));

export * from './auth';
export * from './savings';
export * from './incidents';
export * from './diagnostics';

export const getBuildingList = async (env, search = '') => {
  const BASE_URL = getBaseUrl(env);
  const API_ENDPOINT = search ? `/building/api/buildings/?search=${search}` : GET_BUILDING_LIST_ENDPOINT;
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  let response;

  if (!authToken) {
    await refreshToken(env);
    authToken = JSON.parse(sessionStorage.getItem('token'));
  }

  // Make the request only if there is an authorization token
  if (authToken) {
    response = axios
      .get(`${BASE_URL}${API_ENDPOINT}`, {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          const refreshTokenStatus = await refreshToken(env);
          return refreshTokenStatus === 200 ? getBuildingList(env) : logout();
        }
        return Promise.reject(error.response.data.errors[0].message);
      });
  }

  return response;
};

// export const getCSVData = async (env, apiLocation) => {
//   const BASE_URL = getBaseUrl(env);
//   let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

//   if (!authToken) {
//     await refreshToken(env);

//     authToken = JSON.parse(sessionStorage.getItem('token')) || '';
//   }

//   const response = await axios
//     .post(`${BASE_URL}${apiLocation}export/`, {
//       headers: {
//         'Authorization': `JWT ${authToken}`,
//         'Content-Type': 'application/json',
//       },

//     })
//     .then((response) => {
//       console.log(response)
//       return response.data;
//     }, (error) => {
//       return error.response.data.errors[0].message;
//     });

//   return response;
// }
